<template>
  <div class="not-found">
    <h1>{{ title }}</h1>
  </div>
</template>

<script>
// import Util from '@/util'
export default {
  name: 'NotFound',
  props: {
  },
  created () {
  },
  async mounted () {
  },
  data () {
    return {
      title: '404 Not Found'
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">

.not-found {
}

</style>
